module.exports = __webpack_public_path__ + "static/media/01_centroid_diagram.89183fcf.png";